import * as React from 'react';
import { KeyboardEvent, MouseEvent, CSSProperties } from 'react';
import { classes } from 'typestyle';
import { ARROW_DIMENSIONS } from '../../consts';
import { ArrowSize } from '../../../types';
import LeftArrowIcon from './LeftArrow';
import RightArrowIcon from './RightArrow';

interface ArrowProps {
  direction: 'left' | 'right';
  enabled: boolean;
  onClick: (e: MouseEvent<HTMLOrSVGElement> | KeyboardEvent<HTMLOrSVGElement>) => void;
  show: boolean;
  classPrefix: string | undefined;
  size?: ArrowSize;
}

const Arrow = ({ direction, enabled, onClick, show, classPrefix, size = 'medium' }: ArrowProps) => {
  const ArrowIcon = direction === 'left' ? LeftArrowIcon : RightArrowIcon;

  if (!show) {
    return (
      <div
        style={hiddenButton}
        className={classes(`${classPrefix}-arrow`, `${classPrefix}-arrow-${direction}`)}
      />
    );
  }

  return (
    <div
      style={getButtonStyle(size)}
      className={classes(`${classPrefix}-arrow`, `${classPrefix}-arrow-${direction}`)}
    >
      <ArrowIcon
        enabled={enabled}
        onClick={onClick}
        onKeyDown={onClick}
        tabIndex={0}
        role='button'
        aria-label={direction === 'left' ? 'previous' : 'next'}
        size={size}
      />
    </div>
  );
};

const getButtonStyle = (size: ArrowSize): CSSProperties => {
  return {
    flexShrink: 0,
    height: '100%',
    padding: ARROW_DIMENSIONS[size].padding,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  };
};

const hiddenButton: CSSProperties = {
  display: 'none',
};

export default Arrow;
